// Package Imports
import { z } from 'zod'

export const periodicSearchSchema = z.object({
  page: z.number().optional(),
  query: z.string().optional(),
  // Durum filtresi (Hepsi/Aktif/Pasif). Yoksa hepsi.
  status: z.enum(['ALL', 'ACTIVE', 'PASSIVE']).optional(),
})

export const periodicFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Periyot adı girilmesi zorunludur')
    .max(120, 'Periyot adı en fazla 120 karakter olmalıdır'),
  period_id: z.string().min(1, 'Periyot seçilmesi zorunludur'),
  draft_batch_id: z.string().min(1, 'Taslak üretim grubu seçilmesi zorunludur'),
  is_active: z.boolean(),
})

export type TPeriodicFormSchema = z.infer<typeof periodicFormSchema>
